import { toast } from "react-toastify";

import { Button } from "common/components/ui/Button";
import { DialogDescription, DialogTitle } from "common/components/ui/Dialog";
import { DrawerDescription, DrawerTitle } from "common/components/ui/Drawer";
import useLicenseMutations from "common/datahooks/useLicenseMutations";
import { HTTPError } from "common/helpers/HTTP";
import useTwBreakpoint from "common/hooks/useTwBreakpoint";

interface AssignLicenseProps {
  accountId: string;
  accountFullname: string;
  goBack: () => void;
  onSuccess: () => void;
}

export default function AssignLicense({
  accountId,
  accountFullname,
  goBack,
  onSuccess,
}: AssignLicenseProps) {
  const isDesktop = useTwBreakpoint("lg");

  const { assignLicense, isAssigningLicense } = useLicenseMutations();

  function onAssign() {
    assignLicense({ accountId })
      .then(onSuccess)
      .catch((error) => {
        toast.error(
          error instanceof HTTPError && error.serverMessage
            ? error.serverMessage
            : "Failed to assign seat",
        );
      });
  }

  const Title = isDesktop ? DialogTitle : DrawerTitle;
  const Description = isDesktop ? DialogDescription : DrawerDescription;

  return (
    <>
      <Title>Assign seat to "{accountFullname}"?</Title>
      <Description className="mb-8">
        You will get full access to LinkedIn Outreach and campaigns
      </Description>

      <div className="flex gap-x-2.5 justify-between">
        <Button
          onClick={goBack}
          variant="secondary-black"
          disabled={isAssigningLicense}
          className="lg:flex-1"
        >
          Cancel
        </Button>
        <Button
          isLoading={isAssigningLicense}
          onClick={onAssign}
          variant="gradient"
          className="lg:flex-1"
        >
          Assign
        </Button>
      </div>
    </>
  );
}
